<template>
  <Head title="Organization Settings" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <organization-settings 
            :client="client" 
            :tab_name="tab_name" 
            :integrations="integrations ?? []" 
            :connections="connections ?? []" 
            :datablends="datablends ?? []" 
            :files="files ?? []" 
            :num_files="num_files ?? 0"  
            :census_connections="census_connections ?? []" 
            :segments="segments ?? []"
            :user="auth.user" 
          ></organization-settings>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  tab_name: String,
  integrations: Array,
  connections: Array,
  datablends: Array,
  files: Array,
  num_files: Number,
  census_connections: Array,
  segments: Array,
  auth: Object
});
</script>

